import PlannerDriverPlanOrderRequest from "../../../api/raily/planner/order/planning-driver-plan-order.request";
import PlannerDriverPlanOrderParams from "./planner-driver-plan-order-params";

const create = (
  params: PlannerDriverPlanOrderParams,
): PlannerDriverPlanOrderRequest => {
  return {
    orderId: params.orderUuid,
  };
};

const plannerDriverPlanOrderParamsFactory = {
  create,
};

export default plannerDriverPlanOrderParamsFactory;
